import React, {useState, useEffect } from 'react';
import { Box, Button, TextField, Typography,
    MenuItem,
    Radio,
    FormControlLabel,
    RadioGroup,
    ListItemText
} from '@mui/material';
import InputField from '../../components/formElements/InputField';
import SelectField from '../../components/formElements/SelectField';
import {useDispatch } from "react-redux";
import {display} from '../../redux/reducers/sidebar';
import AddIcon from '@mui/icons-material/Add';
import CreateNewGroup from '../../components/modals/CreateNewGroup';


function CreateLedgerAccount() {
    const dispatch = useDispatch();
    dispatch(display());

    const [newGroupModal, SetNewDroupModal] = useState(false)

    const { innerWidth, innerHeight } = window;
    let divHeight = innerHeight - 250;

    useEffect(() => {
        divHeight = innerHeight - 250;
     },[innerHeight])

  return (
    <Box sx={{width:'100%',paddingTop:'80px',boxSizing:'border-box',display:'flex',flexDirection:'column',}}>
        <Box
            sx={{
                marginLeft : {xs:'20px',sm:'80px'},
                marginRight:{xs:'20px',sm:'30px'},
            }}
        >

            <Box
                sx={{
                    borderRadius:'8px',
                    backgroundColor : "background.paper",
                    marginBottom:'20px',
                    boxShadow: 'rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset',
                    padding:{xs:'10px 0px',sm:'10px 10px'},
                    borderRadius:'8px',
                    ':hover' : {
                        boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
                    },
                    transition:'all 1s ease-in-out'
                }}
            >
                <Box sx={{display:'flex',alignItems:{sm:'center'},flexWrap:{xs:'wrap',md:'nowrap'},flexDirection:{xs:'column',sm:'row'},marginBottom:'0px'}}>
                    <Box sx={{flex:{xs:1,sm:.5},m:1}}>
                        <InputField
                            name='Account Name'
                            placeholder='Account Name'
                            size='small'
                            type='text'
                            
                        />
                    </Box>
                    <Box sx={{flex:{xs:1,sm:.5},m:1}}>
                        <Box sx={{
                            position: 'relative',
                            border: 'solid 1px',
                            borderColor: 'input.border',
                            borderRadius: '4px',
                            padding: '10px 14px',
                            '.css-ahj2mt-MuiTypography-root': {
                                fontSize: '12px',
                                color: 'input.font'
                            },
                            '.css-1n70hd2-MuiButtonBase-root-MuiRadio-root': {
                                padding: '0px',
                                margin: '0px 5px'
                            },
                            '.css-1rfdfc4-MuiButtonBase-root-MuiRadio-root': {
                                padding: '0px',
                                margin: '0px 5px',
                                color: 'input.border'
                            },
                            '.css-1rfdfc4-MuiButtonBase-root-MuiRadio-root.Mui-checked': {
                                color: 'primary.main'
                            },
                        }}>
                            <Typography sx={{ fontSize: '0.75em', letterSpacing: '0.00938em', position: 'absolute', top: '-10px', left: '9px', background: '#fff', padding: '0px 3px', color: 'input.font' }}>Account Type</Typography>
                            <RadioGroup sx={{ display: 'flex', flexDirection: { xs: 'row', sm: 'row' } }}>
                                <FormControlLabel value="Percentage" control={<Radio size='small' disableRipple />} label="Balance Sheet" />
                                <FormControlLabel value="Amount" control={<Radio size='small' />} label="Profit & Loss" />
                            </RadioGroup>
                        </Box>
                    </Box>
                    <Box sx={{flex:{xs:1,sm:.5},m:1}}>
                        <TextField
                            select
                            // value=''
                            id='measurement'
                            label='Group Head'
                            variant="outlined"
                            size='small'
                            fullWidth
                            sx={{
                                '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                                    fontSize: '14px'
                                },
                                'label': {
                                    fontSize: '14px'
                                },
                                '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                                    fontSize: '14px'
                                },
                                '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                                    color: 'input.font'
                                },
                                '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'input.border'
                                },
                                '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                                    color: 'input.font'
                                }
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        >
                            {['Office Furniture', 'Fixed Assets', 'Group Name', 'Group Head'].map(item => {
                                return <MenuItem key={item} value={item}>
                                    <ListItemText primary={item} />
                                </MenuItem>
                            })}
                            <MenuItem
                                value={'newGroup'}
                                onClick={() => SetNewDroupModal(true)}
                            >
                                <AddIcon fontSize='small' sx={{ marginRight: '5px' }} />
                                <ListItemText primary={'Create new group'} />
                            </MenuItem>

                        </TextField>
                    </Box>
                </Box>
            </Box>

            <Box
                sx={{
                    borderRadius:'8px',
                    backgroundColor : "background.paper",
                    marginBottom:'20px',
                    boxShadow: 'rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset',
                    padding:{xs:'10px 0px',sm:'10px 10px'},
                    borderRadius:'8px',
                    ':hover' : {
                        boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
                    },
                    transition:'all 1s ease-in-out'
                }}
            >

                <Box sx={{display:'flex',alignItems:{sm:''},flexWrap:{xs:'wrap',md:'nowrap'},flexDirection:{xs:'column',sm:'row'},marginBottom:'0px'}}>
                    <Box sx={{flex:{xs:1,sm:.5},m:1}}>
                        <InputField
                            name='HSN/SAC Code'
                            placeholder='HSN/SAC Code'
                            size='small'
                            type='text'
                            
                        />
                    </Box>
                    <Box sx={{flex:{xs:1,sm:.5},m:1}}>
                        <SelectField 
                            name='GST Rate'
                            placeholder='GST Rate'
                            size='small'
                            
                            // value=''
                            options={[
                                {option:'8%',value:'8%'},
                                {option:'12%',value:'12%'},
                                {option:'18%',value:'18%'},
                            ]}
                        />
                    </Box>
                    <Box sx={{flex:{xs:1,sm:.5},m:1}}>
                        <InputField
                            name='GST Compensation Cess'
                            placeholder='GST Compensation Cess'
                            size='small'
                            type='text'
                            
                        />
                    </Box>
                </Box>
            </Box>

            <Box sx={{
                marginTop:'10px',
                width:'100%',
                display:'flex',
                justifyContent:{xs:'space-around',sm:'end'},
                flexWrap:'wrap',
                flexDirection:{xs:'column',sm:'row'},
            }}>
                <Button variant='text' disableElevation disableRipple sx={{fontSize:'12px',marginBottom:'15px',marginLeft:{xs:'0px',sm:'20px',backgroundColor:'#'}}} >Cancel</Button>
                <Button variant='outlined' disableElevation disableRipple sx={{fontSize:'12px',marginBottom:'15px',marginLeft:{xs:'0px',sm:'20px',backgroundColor:'#'}}} >Save & New</Button>
                <Button variant='contained' disableElevation disableRipple sx={{fontSize:'12px',marginBottom:'15px',marginLeft:{xs:'0px',sm:'20px'}}} >Save</Button>
            </Box>

        </Box>

        <CreateNewGroup open={newGroupModal} setOpen={SetNewDroupModal}  />
    </Box>
  )
}

export default CreateLedgerAccount